import React from "react";
import logoSuperDucha from "../../../../assets/images/logo-super-ducha-white.png";
import { restartInteraction } from "../../../../stores/VacuumStore/VacuumStore";
import { FinishButton, TextContainer } from "./FailedActivationStyles";
import {
  GradientContainer,
  LogoSuperDucha,
  LogoWrapper,
  Subtitle,
} from "../../TotemVacuumStyles";

const FailedActivation: React.FC = () => {
  const handleRestart = () => {
    restartInteraction();
  };

  return (
    <GradientContainer>
      <LogoWrapper>
        <LogoSuperDucha src={logoSuperDucha} alt="Super Ducha" />
      </LogoWrapper>
      <TextContainer>
        <Subtitle fontSize={"2.25rem"}>Falha ao ativar o aspirador</Subtitle>
        <Subtitle fontSize={"2.25rem"}>
          Exiba esta tela para um atendente
        </Subtitle>
        <FinishButton onClick={handleRestart}>Sair</FinishButton>
      </TextContainer>
    </GradientContainer>
  );
};

export default FailedActivation;
